import React, { useState } from "react";
import ReactModal from "react-modal";
import Checkbox from "src/components/Checkbox";
import { FC_FLOW_PRE_URL } from "../../../../../services/api";
import {
  CloseButton,
  Container,
  Line,
  Link,
  ModalHeader,
  Terms,
  SmallText,
  TextBlock,
  CustomButton,
  ContainerCTA,
  Button
} from "./styles";
import { eventTrack } from "src/components/GoogleTagManager";

function Footer({ buttonColor, terms, disabled, cupons, textColor }) {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Container>
        <Terms isChecked={checked}>
          <Checkbox
            id="check-term"
            onChange={() => {
              setChecked(!checked);
              eventTrack(
                'veloe:institucional',
                'interacao:checkbox',
                'check-term:' + String(!checked)
              );
            }}
            className="termoAceite"
          />
          <label htmlFor="check-term">
            Estou ciente que, ao prosseguir, aceito o{" "}
            <b onClick={(e) => {
              e.preventDefault()
              !disabled && setOpenModal(true)}
            }>
              regulamento
            </b>{" "}
            da campanha.
          </label>
        </Terms>
        <div className="botoesCupons">
          <Link
            disabled={!checked}
            href={
              disabled
                ? ""
                : `${FC_FLOW_PRE_URL}?origem=lp&codigo=${"BRALPEXCLUSIVEPRE6"}`
            }
          >
            <Button
							background='#CC092F' color='#fff'
							disabled={!checked}
              onClick={() => eventTrack(
                'veloe:institucional',
                'clique:botao',
                'planos:peca-ja'
              )}
						>
							Peça já
						</Button>
          </Link>
        </div>
      </Container>
      <ReactModal isOpen={openModal} onRequestClose={() => setOpenModal(false)}>
        <ModalHeader>
          <CloseButton
            src="/bradescoexclusive/assets/icon-close.png"
            onClick={() => setOpenModal(false)}
          />
        </ModalHeader>
        <div>
          {terms.content &&
            terms.content?.map((term, index) => (
              <Line key={index}>
                {term.content.map(({ value, marks }) => {
                  const className = !!marks
                    ? marks.map((mark) => mark.type).join(" ")
                    : "";
                  return <TextBlock className={className}>{value}</TextBlock>;
                })}
              </Line>
            ))}
        </div>
      </ReactModal>
    </>
  );
}

export default Footer;
